import TemplateView from '../../../../../TemplateView'

export default class CheckContent extends TemplateView {

    templateHtml() {
        return '<div class="check">' +
               '    <div><%=title%></div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licenses.purchase.purchase_step.check.title',
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/CheckContent.js